module.exports = __webpack_public_path__ + "static/img/组 2819.d46d315.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inAndOut/cancelled/images/组 2819.png
// module id = Ax8B
// module chunks = 0